import React, { useState } from 'react';
import { string, bool } from 'prop-types';
import { Play, Pause } from '@one-thd/sui-icons';
import classNames from 'classnames/bind';
import styles from './video-hero-image.scss';

const VideoHeroImage = ({
  imageUrl = '',
  altText = '',
  fullWidth = false,
  brandHero = false,
  videoClasses = '',
  isBentoHero = false,
  hrefLink = '',
  desktopVideoUrl = '',
  mobileVideoUrl = ''
}) => {
  const [videoPaused, setVideoPaused] = useState(false);

  const handlePlayPause = (event) => {
    event.stopPropagation();
    const videoElement = event.currentTarget.closest('.video-hero-image')?.querySelector('video');

    if (!videoElement) return;

    setVideoPaused((prev) => {
      if (prev) {
        videoElement.play();
      } else {
        videoElement.pause();
      }
      return !prev;
    });
  };

  const handleVideoClick = () => {
    if (isBentoHero && hrefLink) {
      window.location.href = hrefLink;
    }
  };

  const videoButton = (
    <button
      type="button"
      className="hero-video-button sui-absolute sui-bottom-4 sui-right-4 sui-flex sui-justify-end sui-items-end"
      aria-label="pause or play video"
      onClick={handlePlayPause}
      onKeyUp={(event) => event.stopPropagation()}
    >
      <div
        data-testid="play-button"
        className={`
          play-button sui-h-12 sui-w-12 sui-justify-center 
          sui-items-center sui-bg-inactive sui-rounded-full 
          ${videoPaused ? 'sui-flex' : 'sui-hidden'}`}
      >
        <div className="play-button-hover sui-pl-1"><Play color="brand" size="small" /></div>
        <div className="play-button-no-hover sui-pl-1"><Play color="primary" size="small" /></div>
      </div>
      <div
        className={
          `pause-button sui-h-12 sui-w-12 sui-justify-center 
          sui-items-center sui-bg-inactive sui-rounded-full 
          ${videoPaused ? 'sui-hidden' : 'sui-flex'}`
        }
      >
        <div className="pause-button-hover"><Pause color="brand" size="small" /></div>
        <div className="pause-button-no-hover"><Pause color="primary" size="small" /></div>
      </div>
    </button>
  );

  const containerClasses = classNames(
    'video-hero-image sui-overflow-hidden sui-relative',
    {
      'sui-w-full': fullWidth,
      'sui-row-start-1 md:sui-row-start-auto': brandHero,
      'sui-col-span-12 lg:sui-col-span-8 sui-aspect-[1.43/1] md:sui-aspect-[3/1] lg:sui-aspect-[3.33/1]': isBentoHero
    }
  );

  return (
    <div
      className={containerClasses}
      onClick={handleVideoClick}
      role="button"
      tabIndex={0}
      onKeyDown={(event) => {
        if (event.key === ' ') {
          event.preventDefault();
          handleVideoClick();
        }
      }}
    >
      <video
        className={videoClasses}
        aria-label={altText}
        autoPlay
        playsInline
        muted
        loop
        controls=""
      >
        {isBentoHero ? (
          <>
            <source src={desktopVideoUrl} type="video/mp4" media="(min-width: 1024px)" />
            <source src={mobileVideoUrl} type="video/mp4" />
          </>
        ) : (
          <source src={imageUrl} type="video/mp4" />
        )}
      </video>
      {videoButton}
    </div>
  );
};

VideoHeroImage.propTypes = {
  imageUrl: string,
  altText: string,
  fullWidth: bool,
  brandHero: bool,
  videoClasses: string,
  isBentoHero: bool,
  hrefLink: string,
  desktopVideoUrl: string,
  mobileVideoUrl: string
};

export { VideoHeroImage };
